<div class="progress-wrapper" *ngIf="!loadingState" [ngStyle]="getTotalProgressBarStyles()">
  <app-story-progress-bar *ngFor="let progress of stories; let i = index;trackBy:trackByFn" [duration]="progress?.duration"
    [isActive]="activeIndex === i" [storyProgressPercentage]="storyProgressPercentage" [completed]="activeIndex > i ? true : false">
  </app-story-progress-bar>
</div>
<div class="progress-wrapper" *ngIf="loadingState" [ngStyle]="getTotalProgressBarStyles()">
  <app-story-progress-bar 
    [isActive]="true" [completed]="false">
  </app-story-progress-bar>
</div>
